import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const modalFooter = css`
  justify-content: flex-end;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    justify-content: flex-start;
    gap: 0.75rem;
    margin: 0;
  }
`;

export const button = css`
  margin-left: 1rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin: 0;
  }
`;
